import { render, staticRenderFns } from "./AddCustomField.vue?vue&type=template&id=00589870&"
import script from "./AddCustomField.vue?vue&type=script&lang=ts&"
export * from "./AddCustomField.vue?vue&type=script&lang=ts&"
import style0 from "./AddCustomField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports